import React from "react";
import "./Companies.css";

function Companies() {
  return (
    <>
      <section className="c-warpper">
        <div className="paddings innerWidth flexCenter c-container">
          <img src="./media/prologis.png" alt="prologis" />
          <img src="./media/tower.png" alt="tower" />
          <img src="./media/realty.png" alt="realty" />
          <img src="./media/equinix.png" alt="equinix" />
        </div>
      </section>
    </>
  );
}

export default Companies;
